import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import company from '../assets/img/images.jpg';
import moment from 'moment';
import 'moment/locale/hy-am.js';
import {word} from '../word.js'
import {ClipLoader} from "react-spinners";
import {Col, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import Account from "../helpers/Account.js";
import AddManToCompany from "../components/AddManToCompany.js";
import DeleteManCompany from "../components/DeleteManCompany.js";
import DeleteCompany from "../components/DeleteCompany.js";
import EditCompany from "../components/EditCompany.js";
import {singleCompanyRequest} from "../store/actions/companies.js";
import {useDispatch, useSelector} from "react-redux";
const {profession} = Account.getData()

function OrganizationSingle(props) {
    const params = useParams()
    const dispatch = useDispatch()
    const {id} = params;
    const single = useSelector((state) => state.companies.single);
    const [org, setOrg] = useState({});
    const [show, setShow] = useState(false);
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [editShow, setEditShow] = useState(false);
    const [url, setUrl] = useState('');
    const [list] = useState([
        { id: 1, name: 'Գործող' },
        { id: 2, name: 'Չգործող' }
    ]);

    useEffect(() => {
        (async () => {
            await dispatch(singleCompanyRequest(id))
        })()
    }, [id]);

    useEffect(() => {
        setOrg(single);
    }, [single]);

    const ellipsisString = (string, maxChar) => {
        if (maxChar < string?.length) {
            return string.slice(0, maxChar) + '...';
        }
        return string;
    };



    const _returnString = (array) => {
        return array.map((element) => element.name).join(', ');
    };


    if (!org.url) {
        return (
            <div className="loaderMargin">
                <ClipLoader type="Oval" color="#101C2A" size={30} />
            </div>
        );
    }

    return (
        <Wrapper>
            <div className="my-user-org-page">
                <div className="header-line"/>
                <div className="modules-header"/>

                <div className="my-page-cont">
                    <div className="container">
                        <Row className="img-name">
                            <div className="image-round">
                                <div
                                    className="my-image"
                                    style={{
                                        backgroundImage: org.logo ? `url(${org.logo})` : `url(${company})`
                                    }}
                                />
                            </div>
                            <h1>{org.name !== 'undefined' ? ellipsisString(org.name, 20) : ''}</h1>
                        </Row>
                        <div className="data-section">

                            <div className="container">
                                <p className="data-section">{word.org_name}</p>
                                <div className="edit-delete-cont">
                                    <div className="tool-tip-cont">
                                        <div className="tool-tip">Խմբագրել</div>
                                        {profession === 'manager' && (
                                            <span onClick={() => setEditShow(true)} className="icon-Compose"/>
                                        )}
                                    </div>
                                    {org.is_deleted && (
                                        <div className="tool-tip-cont">
                                            <div className="tool-tip">Ջնջել</div>
                                            <i className="fas fa-trash-alt" onClick={() => setDeleteVisible(true)}/>
                                        </div>
                                    )}
                                </div>
                                <Row className="my-data">
                                    <Col xs={6} sm={6}>
                                        <p className="data-line">{word._name}</p>
                                        <p className="data-line">{word.phone}</p>
                                        <p className="data-line">{word.email}</p>
                                        <p className="data-line">{word.address}</p>
                                        <p className="data-line">{word.HVHH}</p>
                                        <p className="data-line">{word.directorLastName}</p>
                                        <p className="data-line">{word.category}</p>
                                        <p className="data-line">Պայմանագրի սկիզբ</p>
                                        <p className="data-line">{word.activityType}</p>
                                        <p className="data-line">{word.type_of_service}</p>
                                        <p className="data-line">{word.taxationSystem}</p>
                                        <p className="data-line">{word.numberEmployees}</p>
                                        <p className="data-line">{word.change_data}</p>
                                    </Col>
                                    <Col xs={6} sm={6}>
                                        <p className="data-line">
                                            <span>{org.name !== 'undefined' ? ellipsisString(org.name, 38) : ''}</span>
                                        </p>
                                        <p className="data-line">{org.client.phone}</p>
                                        <p className="data-line">{org.client.user.email}</p>
                                        <p className="data-line">{org.address}</p>
                                        <p className="data-line">{org.HVHH}</p>
                                        <p className="data-line">{org.director_full_name}</p>
                                        {org.category && <p className="data-line">{list[org.category]?.name}</p>}
                                        <p className="data-line">{org.agreement_date ? moment(org.agreement_date).format('LL') : null}</p>
                                        <p className="data-line">{_returnString(org.type_of_activity)}</p>
                                        <p className="data-line">{_returnString(org.service)}</p>
                                        <p className="data-line">{org.taxation_system ? org.taxation_system.name : ''}</p>
                                        <p className="data-line">{org.count_employees}</p>
                                        <p className="data-line">{org.change_data !== 'null' ? ellipsisString(org.change_data, 38) : ''}</p>
                                    </Col>
                                </Row>
                                <a className="company-task" href={`/main_employee/tasks?company=${org.id}`}>
                                    <div className="blue-button">{word.company_tasks}</div>
                                </a>
                                <p className="data-section">{word.stuffs}</p>
                                {profession !== 'accountant' && (
                                    <div className="plus" onClick={() => setShow(true)}>
                                        +
                                    </div>
                                )}
                                <Row className="org-section">
                                    {org.accountant.map((item, index) => (
                                        <div className="org-item" key={index}>
                                            <div
                                                className="organizations-logo"
                                                style={{ backgroundImage: `url(${item.image})` }}
                                            >
                                                {profession !== 'accountant' && (
                                                    <div className="tool-tip-cont">
                                                        <div className="tool-tip">Ջնջել</div>
                                                        <i
                                                            className="fas fa-times"
                                                            onClick={() => {
                                                                setDeleteShow(true);
                                                                setUrl(item.url);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {item.name !== 'undefined' && (
                                                <div className="logo-name">
                                                    {item.user.first_name} {item.user.last_name}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {show?<AddManToCompany setData={setOrg} data={org} open={show} setOpen={setShow}/>:null}
            {deleteShow?<DeleteManCompany url={url} setData={setOrg} org={org} open={deleteShow} setOpen={setDeleteShow}/>:null}
            {deleteVisible?<DeleteCompany  setData={setOrg} org={org} open={deleteVisible} setOpen={setDeleteVisible}/>:null}
            {editShow?<EditCompany setData={setOrg} data={org} open={editShow} setOpen={setEditShow}/>:null}
        </Wrapper>
    );
}

export default OrganizationSingle;